import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "14",
  viewBox: "0 0 24 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<mask id=\"mask0_1279_17476\" style=\"mask-type:luminance;\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"24\" height=\"14\"><path d=\"M24 0H0V14H24V0Z\" fill=\"white\"></path></mask><g mask=\"url(#mask0_1279_17476)\"><mask id=\"mask1_1279_17476\" style=\"mask-type:luminance;\" maskUnits=\"userSpaceOnUse\" x=\"-1\" y=\"-1\" width=\"26\" height=\"16\"><path d=\"M24.2798 -0.147339H-0.191406V14.2314H24.2798V-0.147339Z\" fill=\"white\"></path></mask><g mask=\"url(#mask1_1279_17476)\"><path d=\"M7.96567 -0.147339H-0.191406V14.2314H7.96567V-0.147339Z\" fill=\"#323E95\"></path><path d=\"M16.1224 -0.147339H7.96533V14.2314H16.1224V-0.147339Z\" fill=\"#F1F2F1\"></path><path d=\"M24.2796 -0.147339H16.1226V14.2314H24.2796V-0.147339Z\" fill=\"#FF0F21\"></path></g></g>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }